import { render, staticRenderFns } from "./LoginPassword.vue?vue&type=template&id=ad9872ee&scoped=true&"
import script from "./LoginPassword.vue?vue&type=script&lang=js&"
export * from "./LoginPassword.vue?vue&type=script&lang=js&"
import style0 from "./LoginPassword.vue?vue&type=style&index=0&id=ad9872ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9872ee",
  null
  
)

export default component.exports